/**
 * The landing page arrives as static HTML.
 *
 * `npm run build` ends by rendering `<Landing>` to a string and writing it into
 * `dist/index.html` (scripts/prerender.ts → src/prerender.tsx), so a crawler
 * that runs no JavaScript, and a visitor whose script has not arrived yet, get
 * the page itself rather than an empty `#root`. Two moments have to know:
 *
 *   - the build, which must render the page *settled*: framer-motion writes an
 *     element's `initial` state — opacity 0 — into server markup, and
 *     `useReducedMotion()` is null on the server;
 *   - the client's first mount over that markup, which must not make a page
 *     already on screen fade in a second time.
 *
 * Both arm this flag; the landing page claims it once, in a state initialiser,
 * and renders as it does under reduced motion. A later visit to `/` within the
 * same session finds it spent and animates as before.
 */

let armed = false

/** Before rendering the landing page onto static markup, or over it. */
export function expectStaticLanding(): void {
  armed = true
}

/** True for the one landing-page mount that follows `expectStaticLanding()`. */
export function claimStaticLanding(): boolean {
  const was = armed
  armed = false
  return was
}
